import { URL } from ".";
import fetchApi from "../util/fetchApi";

export default class AuthService {
  async signup(data) {
    return (await fetchApi.post(`${URL}/user/signup`, data)).data;
  }

  async login(loginId, password, fromAdmin) {
    return (
      await fetchApi.post(`${URL}/user/login`, {
        loginId,
        password,
        fromAdmin,
      })
    ).data;
  }

  async logout() {
    return (await fetchApi.get(`${URL}/user/logout`)).data;
  }

  async getAuthUser() {
    return (await fetchApi.get(`${URL}/user/getAuthUser`)).data;
  }

  async forgotPassword(EmailId) {
    return (
      await fetchApi.post(`${URL}/user/forgotPassword`, {
        EmailId,
      })
    ).data;
  }

  async getUserByPasswordResetToken(token) {
    return (await fetchApi.get(`${URL}/user/resetPassword/${token}`)).data;
  }

  async resetPassword(token, Password) {
    return (
      await fetchApi.patch(`${URL}/user/resetPassword/${token}`, {
        Password,
      })
    ).data;
  }
}
